import { createFileRoute } from "@tanstack/react-router";
import type { FermentationGroupId } from "@brewbase/db/types";
import { CleaningSection } from "@/features/fermentation-journal/components/aftercare";

export const Route = createFileRoute("/fermentations/$group_id/aftercare/cip")({
  component: CipPage,
});

function CipPage() {
  const { group_id } = Route.useParams();
  return (
    <div className="max-w-4xl">
      <CleaningSection
        groupId={group_id as unknown as FermentationGroupId}
        cleaningPosition="post"
        title="Clean-in-Place (CIP)"
      />
    </div>
  );
}
